import React, { Component } from 'react';
import { Link } from 'react-router';

export default class NotFound extends Component {
  render() {
    return (
      <div className="AppAdmin">

        <div className="table-cell">
          <h1 className="emptyHeadline">{this.props.name || '404'}</h1>

          <Link className="SelectSpecialtiesOpen" style={{marginTop: 25}} to={this.props.link || '/admin/'}>{this.props.nameButton || 'На главную'}</Link>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./assets/components/NotFound/index.jsx
 **/